import * as React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { IWithLoadingStatusHOCOptions, TFunctionComponent } from '../../types';

export type TAvatarProps = {
  avatarProps: ManifestUI.AvatarProps;
} & IWithLoadingStatusHOCOptions;

export const Avatar: TFunctionComponent<TAvatarProps> = ({ avatarProps }) => (
  <ManifestUI.Avatar data-testid={'manifestUIAvatar'} {...avatarProps} />
);
